module.exports = __webpack_public_path__ + "img/demo_logo.ab115289.svg";